import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createCardiologyDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterCardiologyFormSchema } from "./schema";
import { DischargeLetterCardiologyFormSections } from "./sections";

export const getDischargeLetterCardiologyFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        admission_medications: value?.admission_medications ?? "",
        allergies: value?.allergies ?? "",
        anamnesis: value?.anamnesis ?? "",
        appointments: value?.appointments ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        ecg: value?.ecg ?? "",
        findings: value?.findings ?? "",
        lab_results: value?.lab_results ?? "",
        laboratory_parameters: value?.laboratory_parameters ?? "",
        physical_status: value?.physical_status ?? "",
        recommendations: value?.recommendations ?? "",
        social_history: value?.social_history ?? "",
        therapy_and_course: value?.therapy_and_course ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formCardiology.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameCarido,
      pdfCreator: createCardiologyDischargeLetterPdf,
    },
    schema: DischargeLetterCardiologyFormSchema,
    sections: DischargeLetterCardiologyFormSections,
  };
};
